import { useQuery, useReactiveVar } from '@apollo/client';
import GET_USER_OBSERVATION_REPORTS_COUNT from '../../../queries/getUserObservationReportsCountQuery';
import { userPrivileges } from '@apollo-internal/cache';
import PrivilegeNames from '../../../../../constants/privilegeNames';
import { ALL_APPRAISER_TABS, BASIC_APPRAISER_TABS } from '../constants/appraiserTabs';

export const useAppraiserTabs = externalUserId => {
  const privileges = useReactiveVar(userPrivileges);

  const { data, loading, error } = useQuery(GET_USER_OBSERVATION_REPORTS_COUNT, {
    variables: { externalUserId: parseInt(externalUserId) },
    skip:
      !externalUserId ||
      !privileges.includes(PrivilegeNames.UserManagement_CertificationPathwayProgress)
  });

  const appraiserTabs =
    data?.userObservationReportsCount > 0 ? ALL_APPRAISER_TABS : BASIC_APPRAISER_TABS;

  return {
    appraiserTabs,
    loading,
    error
  };
};
